var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecFab1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 150,
    viewBox: "0 0 360 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5363_312308)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 150,
    fill: "#E2E5E5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_5363_312308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 51,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 76H91V82H89V76H83V74H89V68H91V74H97V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 63.5,
    width: 23,
    height: 23,
    stroke: "#FF1844"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_5363_312308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 51,
    width: 146,
    height: 48,
    rx: 24,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 76H173V82H171V76H165V74H171V68H173V74H179V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.953 75.1543H200.088C200.849 75.1543 201.4 75.013 201.742 74.7305C202.084 74.4479 202.255 74.0286 202.255 73.4727C202.255 72.9076 202.07 72.502 201.701 72.2559C201.332 72.0098 200.776 71.8867 200.033 71.8867H198.953V75.1543ZM198.953 76.5078V80.5H197.319V70.5059H200.143C201.432 70.5059 202.387 70.7474 203.007 71.2305C203.627 71.7135 203.937 72.4427 203.937 73.418C203.937 74.6621 203.289 75.5485 201.995 76.0771L204.818 80.5H202.959L200.566 76.5078H198.953ZM209.405 80.6367C208.229 80.6367 207.309 80.2949 206.644 79.6113C205.983 78.9232 205.652 77.9775 205.652 76.7744C205.652 75.5394 205.96 74.5687 206.575 73.8623C207.19 73.1559 208.036 72.8027 209.111 72.8027C210.109 72.8027 210.898 73.1058 211.477 73.7119C212.055 74.318 212.345 75.152 212.345 76.2139V77.082H207.307C207.329 77.8158 207.528 78.3809 207.901 78.7773C208.275 79.1693 208.801 79.3652 209.48 79.3652C209.927 79.3652 210.342 79.3242 210.725 79.2422C211.112 79.1556 211.527 79.0143 211.969 78.8184V80.124C211.577 80.3109 211.18 80.443 210.779 80.5205C210.378 80.598 209.92 80.6367 209.405 80.6367ZM209.111 74.0195C208.601 74.0195 208.191 74.1813 207.881 74.5049C207.576 74.8285 207.393 75.3001 207.334 75.9199H210.766C210.757 75.2956 210.606 74.8239 210.314 74.5049C210.023 74.1813 209.622 74.0195 209.111 74.0195ZM220.555 72.9395V73.8213L219.263 74.0605C219.381 74.2201 219.479 74.416 219.557 74.6484C219.634 74.8809 219.673 75.127 219.673 75.3867C219.673 76.166 219.404 76.779 218.866 77.2256C218.328 77.6722 217.588 77.8955 216.645 77.8955C216.403 77.8955 216.184 77.8773 215.988 77.8408C215.642 78.055 215.469 78.3057 215.469 78.5928C215.469 78.766 215.549 78.8958 215.708 78.9824C215.872 79.069 216.171 79.1123 216.604 79.1123H217.923C218.757 79.1123 219.39 79.29 219.823 79.6455C220.256 80.001 220.473 80.5137 220.473 81.1836C220.473 82.0404 220.119 82.7012 219.413 83.166C218.707 83.6309 217.686 83.8633 216.351 83.8633C215.321 83.8633 214.535 83.681 213.992 83.3164C213.45 82.9518 213.179 82.4323 213.179 81.7578C213.179 81.293 213.325 80.901 213.616 80.582C213.912 80.2676 214.325 80.0488 214.854 79.9258C214.639 79.8346 214.462 79.6888 214.32 79.4883C214.184 79.2832 214.115 79.069 214.115 78.8457C214.115 78.5632 214.195 78.3239 214.354 78.1279C214.514 77.932 214.751 77.7383 215.065 77.5469C214.674 77.3783 214.354 77.1048 214.108 76.7266C213.867 76.3438 213.746 75.8971 213.746 75.3867C213.746 74.5664 214.004 73.9307 214.519 73.4795C215.038 73.0283 215.776 72.8027 216.733 72.8027C216.948 72.8027 217.171 72.8187 217.403 72.8506C217.64 72.8779 217.818 72.9076 217.937 72.9395H220.555ZM214.614 81.6758C214.614 82.0221 214.769 82.2887 215.079 82.4756C215.394 82.6624 215.833 82.7559 216.398 82.7559C217.273 82.7559 217.925 82.6305 218.354 82.3799C218.782 82.1292 218.996 81.7965 218.996 81.3818C218.996 81.0537 218.878 80.819 218.641 80.6777C218.408 80.541 217.973 80.4727 217.335 80.4727H216.118C215.658 80.4727 215.291 80.5798 215.018 80.7939C214.749 81.0127 214.614 81.3066 214.614 81.6758ZM215.305 75.3867C215.305 75.8607 215.425 76.2253 215.667 76.4805C215.913 76.7357 216.264 76.8633 216.72 76.8633C217.649 76.8633 218.114 76.3665 218.114 75.373C218.114 74.8809 217.998 74.5026 217.766 74.2383C217.538 73.9694 217.189 73.835 216.72 73.835C216.255 73.835 215.902 73.9671 215.66 74.2314C215.423 74.4958 215.305 74.8809 215.305 75.3867ZM227.295 80.5L227.069 79.5088H226.987C226.764 79.8597 226.445 80.1354 226.03 80.3359C225.62 80.5365 225.151 80.6367 224.622 80.6367C223.706 80.6367 223.022 80.4089 222.571 79.9531C222.12 79.4974 221.895 78.807 221.895 77.8818V72.9395H223.515V77.6016C223.515 78.1803 223.633 78.6156 223.87 78.9072C224.107 79.1943 224.479 79.3379 224.984 79.3379C225.659 79.3379 226.153 79.1374 226.468 78.7363C226.787 78.3307 226.946 77.654 226.946 76.7061V72.9395H228.56V80.5H227.295ZM232.456 80.5H230.85V69.8633H232.456V80.5ZM239.49 80.5L239.169 79.4473H239.114C238.75 79.9076 238.383 80.222 238.014 80.3906C237.645 80.5547 237.171 80.6367 236.592 80.6367C235.849 80.6367 235.268 80.4362 234.849 80.0352C234.434 79.6341 234.227 79.0667 234.227 78.333C234.227 77.5537 234.516 76.9658 235.095 76.5693C235.674 76.1729 236.555 75.9564 237.74 75.9199L239.046 75.8789V75.4756C239.046 74.9925 238.932 74.6325 238.704 74.3955C238.481 74.154 238.132 74.0332 237.658 74.0332C237.271 74.0332 236.899 74.0902 236.544 74.2041C236.188 74.318 235.847 74.4525 235.519 74.6074L234.999 73.459C235.409 73.2448 235.858 73.083 236.346 72.9736C236.833 72.8597 237.294 72.8027 237.727 72.8027C238.688 72.8027 239.413 73.0124 239.9 73.4316C240.393 73.8509 240.639 74.5094 240.639 75.4072V80.5H239.49ZM237.098 79.4062C237.681 79.4062 238.148 79.2445 238.499 78.9209C238.854 78.5928 239.032 78.1348 239.032 77.5469V76.8906L238.062 76.9316C237.305 76.959 236.754 77.0866 236.407 77.3145C236.065 77.5378 235.895 77.8818 235.895 78.3467C235.895 78.6839 235.995 78.946 236.195 79.1328C236.396 79.3151 236.697 79.4062 237.098 79.4062ZM246.716 72.8027C247.039 72.8027 247.306 72.8255 247.516 72.8711L247.358 74.3682C247.131 74.3135 246.894 74.2861 246.647 74.2861C246.005 74.2861 245.483 74.4958 245.082 74.915C244.686 75.3343 244.487 75.8789 244.487 76.5488V80.5H242.881V72.9395H244.139L244.351 74.2725H244.433C244.683 73.8213 245.009 73.4635 245.41 73.1992C245.816 72.9349 246.251 72.8027 246.716 72.8027ZM254.352 80.5H252.731V70.5059H258.371V71.8867H254.352V75.0107H258.118V76.3984H254.352V80.5ZM266.383 80.5L265.385 77.7246H261.563L260.586 80.5H258.863L262.603 70.4648H264.38L268.119 80.5H266.383ZM264.954 76.3164L264.018 73.5957C263.949 73.4134 263.854 73.1263 263.73 72.7344C263.612 72.3424 263.53 72.0553 263.484 71.873C263.361 72.4336 263.181 73.0465 262.944 73.7119L262.042 76.3164H264.954ZM269.438 70.5059H272.405C273.782 70.5059 274.775 70.7064 275.386 71.1074C276.001 71.5085 276.309 72.1419 276.309 73.0078C276.309 73.5911 276.158 74.0765 275.857 74.4639C275.557 74.8512 275.124 75.0951 274.559 75.1953V75.2637C275.26 75.3958 275.775 75.6579 276.104 76.0498C276.436 76.4372 276.603 76.9635 276.603 77.6289C276.603 78.5267 276.288 79.2308 275.659 79.7412C275.035 80.2471 274.164 80.5 273.048 80.5H269.438V70.5059ZM271.072 74.6348H272.645C273.328 74.6348 273.827 74.5277 274.142 74.3135C274.456 74.0947 274.613 73.7256 274.613 73.2061C274.613 72.7367 274.442 72.3971 274.101 72.1875C273.763 71.9779 273.226 71.873 272.487 71.873H271.072V74.6348ZM271.072 75.9609V79.126H272.809C273.492 79.126 274.007 78.9961 274.354 78.7363C274.704 78.472 274.88 78.0573 274.88 77.4922C274.88 76.9727 274.702 76.5876 274.347 76.3369C273.991 76.0863 273.451 75.9609 272.727 75.9609H271.072Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 66.5,
    y1: 51,
    x2: 66.5,
    y2: 27,
    stroke: "#2A7AFF",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.5,
    y1: 51,
    x2: 113.5,
    y2: 27,
    stroke: "#2A7AFF",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 38.5,
    x2: 114,
    y2: 38.5,
    stroke: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(80 30)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.166 40.6572H89.5469V41.6895H88.166V44H86.8945V41.6895H82.3623V40.9443L86.8193 34.0469H88.166V40.6572ZM83.7979 40.6572H86.8945V35.7764L86.7441 36.0498L83.7979 40.6572ZM96.7246 36.6445C96.7246 37.1413 96.5924 37.5833 96.3281 37.9707C96.0684 38.3581 95.7152 38.6611 95.2686 38.8799C95.7881 39.1032 96.1982 39.429 96.499 39.8574C96.8044 40.2858 96.957 40.7712 96.957 41.3135C96.957 42.1748 96.6654 42.8607 96.082 43.3711C95.5033 43.8815 94.7399 44.1367 93.792 44.1367C92.835 44.1367 92.0671 43.8815 91.4883 43.3711C90.9141 42.8561 90.627 42.1702 90.627 41.3135C90.627 40.7757 90.7728 40.2904 91.0645 39.8574C91.3607 39.4245 91.7686 39.0964 92.2881 38.873C91.846 38.6543 91.4974 38.3512 91.2422 37.9639C90.987 37.5765 90.8594 37.1367 90.8594 36.6445C90.8594 35.806 91.1283 35.1406 91.666 34.6484C92.2038 34.1562 92.9124 33.9102 93.792 33.9102C94.667 33.9102 95.3734 34.1562 95.9111 34.6484C96.4535 35.1406 96.7246 35.806 96.7246 36.6445ZM95.6924 41.2861C95.6924 40.7301 95.5146 40.2767 95.1592 39.9258C94.8083 39.5749 94.348 39.3994 93.7783 39.3994C93.2087 39.3994 92.7507 39.5726 92.4043 39.9189C92.0625 40.2653 91.8916 40.721 91.8916 41.2861C91.8916 41.8512 92.0579 42.2956 92.3906 42.6191C92.7279 42.9427 93.195 43.1045 93.792 43.1045C94.3844 43.1045 94.8493 42.9427 95.1865 42.6191C95.5238 42.291 95.6924 41.8467 95.6924 41.2861ZM93.792 34.9492C93.2952 34.9492 92.8919 35.1042 92.582 35.4141C92.2767 35.7194 92.124 36.1364 92.124 36.665C92.124 37.1709 92.2744 37.5811 92.5752 37.8955C92.8805 38.2054 93.2861 38.3604 93.792 38.3604C94.2979 38.3604 94.7012 38.2054 95.002 37.8955C95.3073 37.5811 95.46 37.1709 95.46 36.665C95.46 36.1592 95.3027 35.7467 94.9883 35.4277C94.6738 35.1087 94.2751 34.9492 93.792 34.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(80 91)",
    fill: "#FF1844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3486 105H82.8271V104.091L86.2725 100.263C86.7829 99.6839 87.1338 99.2145 87.3252 98.8545C87.5212 98.4899 87.6191 98.1139 87.6191 97.7266C87.6191 97.207 87.4619 96.7809 87.1475 96.4482C86.833 96.1156 86.4137 95.9492 85.8896 95.9492C85.2607 95.9492 84.7708 96.1292 84.4199 96.4893C84.0736 96.8447 83.9004 97.3415 83.9004 97.9795H82.6357C82.6357 97.0635 82.9297 96.3229 83.5176 95.7578C84.11 95.1927 84.9007 94.9102 85.8896 94.9102C86.8148 94.9102 87.5462 95.154 88.084 95.6416C88.6217 96.1247 88.8906 96.7695 88.8906 97.5762C88.8906 98.556 88.2663 99.7227 87.0176 101.076L84.3516 103.968H89.3486V105ZM96.0273 101.657H97.4082V102.689H96.0273V105H94.7559V102.689H90.2236V101.944L94.6807 95.0469H96.0273V101.657ZM91.6592 101.657H94.7559V96.7764L94.6055 97.0498L91.6592 101.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.5,
    y1: -3,
    x2: 148.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.5,
    y1: -3,
    x2: 183.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.5,
    y1: -3,
    x2: 278.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: -3,
    x2: 160.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.5,
    y1: -3,
    x2: 195.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.5,
    y1: -3,
    x2: 293.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(144 22)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.983 36H149.712V27.5713L147.162 28.5078V27.3594L150.785 25.999H150.983V36ZM161.21 36H154.688V35.0908L158.134 31.2627C158.644 30.6839 158.995 30.2145 159.187 29.8545C159.382 29.4899 159.48 29.1139 159.48 28.7266C159.48 28.207 159.323 27.7809 159.009 27.4482C158.694 27.1156 158.275 26.9492 157.751 26.9492C157.122 26.9492 156.632 27.1292 156.281 27.4893C155.935 27.8447 155.762 28.3415 155.762 28.9795H154.497C154.497 28.0635 154.791 27.3229 155.379 26.7578C155.971 26.1927 156.762 25.9102 157.751 25.9102C158.676 25.9102 159.408 26.154 159.945 26.6416C160.483 27.1247 160.752 27.7695 160.752 28.5762C160.752 29.556 160.128 30.7227 158.879 32.0762L156.213 34.9678H161.21V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(179 22)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.983 36H184.712V27.5713L182.162 28.5078V27.3594L185.785 25.999H185.983V36ZM196.21 36H189.688V35.0908L193.134 31.2627C193.644 30.6839 193.995 30.2145 194.187 29.8545C194.382 29.4899 194.48 29.1139 194.48 28.7266C194.48 28.207 194.323 27.7809 194.009 27.4482C193.694 27.1156 193.275 26.9492 192.751 26.9492C192.122 26.9492 191.632 27.1292 191.281 27.4893C190.935 27.8447 190.762 28.3415 190.762 28.9795H189.497C189.497 28.0635 189.791 27.3229 190.379 26.7578C190.971 26.1927 191.762 25.9102 192.751 25.9102C193.676 25.9102 194.408 26.154 194.945 26.6416C195.483 27.1247 195.752 27.7695 195.752 28.5762C195.752 29.556 195.128 30.7227 193.879 32.0762L191.213 34.9678H196.21V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(276 22)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.983 36H281.712V27.5713L279.162 28.5078V27.3594L282.785 25.999H282.983V36ZM291.651 26.04V27.1133H291.419C290.435 27.1315 289.651 27.4232 289.067 27.9883C288.484 28.5534 288.147 29.3486 288.056 30.374C288.58 29.7725 289.295 29.4717 290.202 29.4717C291.068 29.4717 291.758 29.777 292.273 30.3877C292.793 30.9984 293.053 31.7868 293.053 32.7529C293.053 33.7783 292.772 34.5986 292.212 35.2139C291.656 35.8291 290.909 36.1367 289.97 36.1367C289.017 36.1367 288.245 35.7721 287.652 35.043C287.06 34.3092 286.764 33.3659 286.764 32.2129V31.7275C286.764 29.8955 287.153 28.4964 287.933 27.5303C288.716 26.5596 289.881 26.0628 291.426 26.04H291.651ZM289.99 30.5244C289.557 30.5244 289.159 30.6543 288.794 30.9141C288.429 31.1738 288.176 31.4997 288.035 31.8916V32.3564C288.035 33.1768 288.22 33.8376 288.589 34.3389C288.958 34.8402 289.418 35.0908 289.97 35.0908C290.539 35.0908 290.986 34.8812 291.31 34.4619C291.638 34.0426 291.802 33.4935 291.802 32.8145C291.802 32.1309 291.635 31.5794 291.303 31.1602C290.975 30.7363 290.537 30.5244 289.99 30.5244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5363_312308",
    x: 40,
    y: 30,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.305882 0 0 0 0 0.329412 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5363_312308",
    result: "effect2_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5363_312308",
    result: "effect3_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5363_312308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5363_312308",
    x: 122,
    y: 30,
    width: 198,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.305882 0 0 0 0 0.329412 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5363_312308",
    result: "effect2_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5363_312308",
    result: "effect3_dropShadow_5363_312308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5363_312308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5363_312308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecFab1);
export default __webpack_public_path__ + "static/media/spec-fab-1.97dcba4287fb7f345789c7a730578cec.svg";
export { ForwardRef as ReactComponent };